import React, { useState } from "react";
import { SwitchOption } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";

import { messages } from "./Production.messages";
import styles from "./Production.module.scss";
import { Slide1 } from "./slides/Slide1/Slide1";
import { Slide2 } from "./slides/Slide2/Slide2";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { Slide3 } from "./slides/Slide3/Slide3";
import { Slide4 } from "./slides/Slide4/Slide4";

interface Production {
  title: string;
}

export const Production: React.FC<Production> = () => {
  const { formatMessage } = useIntl();
  const [selectedOption, setSelectedOption] = useState(0);

  const renderSlide = (): JSX.Element => {
    switch (selectedOption) {
      case 0:
        return <Slide1 />;
      case 1:
        return <Slide2 />;
      case 2:
        return <Slide3 />;
      case 3:
        return <Slide4 />;
      default:
        return <Slide1 />;
    }
  };

  return (
    <SimpleLayoutView>
      <div className={styles.Production}>
        <div className={styles.rightComponent}>
          <div className={styles.slide}>{renderSlide()}</div>
          <div className={styles.switch}>
            <SwitchOption
              onClick={setSelectedOption}
              activeItem={selectedOption}
              items={[
                {
                  name: formatMessage(messages.G6_P4_S1_Name),
                },
                {
                  name: formatMessage(messages.G6_P4_S2_Name),
                },
                {
                  name: formatMessage(messages.G6_P4_S3_Name),
                },
                {
                  name: formatMessage(messages.G6_P4_S4_Name),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
